/**
 * The note model's setting before any switch is moved (`ArrangeHints`): which add-ons the board
 * has on to begin with, the same whoever plays. Why each is on or off is said where the
 * switches are (`ArrangeHints`) and counted in docs/07, "The note model's add-ons".
 */

import { ARRANGE_LAYERS, MORE_USUAL, type ArrangeFollow } from "@app/shared-types";

/** The model's setting before any switch is moved. */
export const FOLLOW_ON: ArrangeFollow = {
  hints: [
    "together",
    "breath",
    "spacing",
    "bass",
    "lowest",
    "present",
    "quarter",
    "release",
    "breathmark",
    "marks",
    "over",
    "octave",
    "apart",
    "duet",
    "fifth",
    "restate",
    "top",
    "third",
    "doubled",
    "room",
    "tremolo",
    "mute",
    "bridge",
    "flutter",
    "harmonic",
  ],
  layers: ARRANGE_LAYERS,
  strength: 1,
  more: MORE_USUAL,
};
